export enum OtherMeterDetailField {
  DeviceCategory = 'deviceCategory',
}
